import Chart from 'chart.js/auto';
import Cookies from "js-cookie";
import {
    convertToDays,
    convertForCalc,
    convertWorkHoursToDays,
    convertWorkLessonsToDays,
    convertToNumber,
} from '../helpers/conversion.js';

var changes = false;


// After reloading or saving show the same work area
function showPlanningLastWorkArea() {
    var workAreaId = Cookies.get('work-area-id');
    var workQuotaId = Cookies.get('work-quota-id');
    var workPastorId = Cookies.get('work-pastor-id');

    if (workAreaId > 0) {
        if($('.work-area[data-work-area-id="' + workAreaId + '"]').length){
            $('.work-area').removeClass('active');
            $('.work-area[data-work-area-id="' + workAreaId + '"]').addClass('active');
        }
    }

    if (workQuotaId > 0) {
        if($('.work-quota-item[data-quota-id="' + workQuotaId + '"]').length){
            $('.work-quota-item').removeClass('active');
            $('.work-quota-item[data-quota-id="' + workQuotaId + '"]').addClass('active');
        }
    }

    if(workPastorId > 0){
        if($('.work-pastor[data-pastor-id="' + workPastorId + '"]').length){
            $('.work-area').removeClass('active');
            $('.work-pastor[data-pastor-id="' + workPastorId + '"]').addClass('active');
        }
    }

    setDeltaOnLoad();

    showWorkArea();
    highlightDeltaPlanningNav();
    calculateAllDeltas();
}

// Custom fn when cliking on a Nav or Tab
function initNavAndPastorTabs(){
    // work area gets changed
    $('.work-area').on('click', function() {
        $('#copy-pastor-work-btn').addClass('d-none');
        $('.activity-field, .work-area').removeClass('active');
        $('.activity-field, .work-pastor').removeClass('active');
        $(this).addClass('active');

        Cookies.set('work-pastor-id', 0, { sameSite: 'strict' });
        Cookies.set('work-area-id', $(this).data('work-area-id'), { sameSite: 'strict' });

        showWorkArea();
    });

    // pastor gets changed
    $('.work-quota-item').on('click', function() {
        $('.work-quota-item').removeClass('active');
        $(this).addClass('active');

        Cookies.set('work-quota-id', $(this).data('quota-id'), { sameSite: 'strict' });

        showWorkArea();
    });

    // pastor gets changed
    $('.work-pastor').on('click', function() {
        $('.activity-field, .work-area').removeClass('active');
        $('.activity-field, .work-pastor').removeClass('active');
        $(this).addClass('active');

        Cookies.set('work-area-id', 0, { sameSite: 'strict' });
        Cookies.set('work-pastor-id', $(this).data('pastor-id'), { sameSite: 'strict' });

        showWorkArea();
    });
}

// Show an alert box before exiting the page. Only in case there is changes in the text
function onBeforeUnload(e) {
    if (changes) {
        e.preventDefault();
        e.returnValue = '';
        return;
    }

    delete e['returnValue'];
}

// handle changes in the planning mask
function changesInPlanningMask(){
    const handler = (input) => {
        // console.log(input);
        var container = input.closest('#planning-add-edit-container');
        changes = true;

        // add class to container if fiels have changed
        // so user can be warned about unsaved planning
        if (!container.hasClass('unsaved')) {
            container.addClass('unsaved');
        }

        var row = input.closest('.input-row');
        calculateRow(row);
    };

    $(document).on('input', '#planning-add-edit-container input', function() {
        handler($(this));
    });

    let previousDisplayMode = null;
    let suppressSortAlert = false;

    $(document).on('focus', '#planning-add-edit-container .input-display_mode', function () {
        previousDisplayMode = $(this).val();
    });


    $(document).on('change', '#planning-add-edit-container .input-display_mode', function () {
        const $this = $(this);

        if (suppressSortAlert) {
            suppressSortAlert = false;
            return; // Don't call handler again on rollback
        }

        const confirmed = confirm('Achtung: Diese Änderung wirkt sich auf alle anderen Sortenwahlen dieser Aufgabe aus. Möchten Sie fortfahren?');

        if (confirmed) {
            handler($this); // Proceed only if user confirms
        } else {
            // Roll back the change without triggering confirmation again
            suppressSortAlert = true;
            $this.val(previousDisplayMode).trigger('change');
        }
    });


    // change of the display mode
    $('select.input-display_mode').change(function(){
        let workAreaId = $(this).parents('.work-area-container').data('work-area-id');
        let rowId = $(this).parents('.input-row').data('row-id');
        let value = $(this).val();
        let valueAsText = this.options[this.selectedIndex].text;

        if(workAreaId == undefined){
            return;
        }
        if(rowId == undefined){
            return;
        }

        // change value of all inputs of the same row
        $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] select.input-display_mode`).val(value);
        $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] span.input-display_mode`).html(valueAsText);

        $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] select.input-display_mode`).each(function(){
            handler($(this));
        });
    });

    // change of the custom category
    $('select.input-custom_category_1_id, select.input-custom_category_2_id').change(function(){
        let inputField = $(this);
        let workAreaId = inputField.parents('.work-area-container').data('work-area-id');
        let rowId = inputField.parents('.input-row').data('row-id');
        let value = inputField.val();
        let valueAsText = this.options[this.selectedIndex].text;

        if(workAreaId == undefined){
            return;
        }
        if(rowId == undefined){
            return;
        }

        const modal = new bootstrap.Modal('#change-custom_category-modal',{
            keyboard: false,
            backdrop: 'static',
        });

        $('#change-custom_category-modal [data-approved]').unbind('click').bind('click', function(){
            modal.hide();

            // change value of all inputs of the same row
            if(inputField.hasClass('input-custom_category_1_id')){
                $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] select.input-custom_category_1_id`).val(value);
                $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] span.input-custom_category_1_id`).html(valueAsText);
            }else if(inputField.hasClass('input-custom_category_2_id')){
                $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] select.input-custom_category_2_id`).val(value);
                $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] span.input-custom_category_2_id`).html(valueAsText);
            }
        });

        modal.show();
    });

    // change of the facotr
    $('.work-area-container[data-quota-id="total"] input.input-factor').change(function(){
        const modal = new bootstrap.Modal('#change-factor-modal',{
            keyboard: false,
            backdrop: 'static',
        });

        let workAreaId = $(this).parents('.work-area-container').data('work-area-id');
        let rowId = $(this).parents('.input-row').data('row-id');
        let value = $(this).val();

        $('#change-factor-modal [data-approved]').unbind('click').bind('click', function(){
            modal.hide();

            $(`.work-area-container[data-work-area-id="${workAreaId}"] .input-row[data-row-id="${rowId}"] input.input-factor`).each(function(){
                let change = true;
                if($(this).parents('.work-area-container').data('quota-id') == 'total'){
                    change = false;
                }
                if($(this).parents('.work-area-container').data('quota-id') == 'delta'){
                    change = false;
                }

                if(change){
                    $(this).val(value);
                    $(this).trigger('input');
                }
            })
        });

        modal.show();
    });
}

// Handle the save btn
function saveBtn(){
    // prevent planning save warning from showing up when saving
    $('.planning-save-button').on('click', function(e) {
        changes = false;
    });
}

// Handle the new responsibility modal
function newResponsibility(){
    // open the new responsbility modal
    $('.new-responsibility').on('click', function() {
        var workAreaId = $('.work-area.active').data('work-area-id');

        // set the responsibility id in the modal
        $('#new-responsibility-modal .input-new-responsibility-work-area-id').val(workAreaId);
    });

    $('#new-responsibility-modal .input-new-responsibility').bind('keypress', function(e) {
        if(e.keyCode == 13){
            e.preventDefault();

            // click the modal submit button
            $(".new-responsibility-submit").click();
        }
    });
}

// Handle the rename responsibility modal
function renameResponsibility(){
    // open the rename responsibility modal
    $('.rename-responsibility').on('click', function() {
        var responsibilityId = $(this).data('responsibility-id');
        var pastorId = $(this).data('pastor-id');
        var responsibilityName = $(this).data('responsibility-name');

        // set the responsibility id in the modal
        $('#rename-responsibility-modal .input-rename-responsibility-id').val(responsibilityId);

        // set the pastor id in the modal
        $('#rename-responsibility-modal .input-rename-responsibility-pastor-id').val(pastorId);

        // set the current responsibility name in the modal
        $('#rename-responsibility-modal .input-rename-responsibility').val(responsibilityName);
    });

    $('#rename-responsibility-modal .input-rename-responsibility').bind('keypress', function(e) {
        if(e.keyCode == 13){
            e.preventDefault();

            // click the modal submit button
            $(".rename-responsibility-submit").click();
        }
    });
}

// Keep the unsaved planning warning always on top
function unsavedPlanningWarning(){
    if(!$('.planning-unsaved-warning-container').length){
        return;
    }

    let top = $('#planning-unsaved-warning-container-placeholder').offset().top;

    if($(window).scrollTop() > top){
        top = 0;
    }else{
        top = top - $(window).scrollTop();
    }

    $('.planning-unsaved-warning-container').css('top', top);
}

// Show the active work area
function showWorkArea() {
    var workAreaId = $('.work-area.active').data('work-area-id');
    var workQuotaId = $('.work-quota-item.active').data('quota-id');
    var workPastorId = $('.work-pastor.active').data('pastor-id');

    $('.work-area-container').removeClass('active');

    if(workPastorId){
        // Show pastor infos
        showPastorInfo();

        $('.planning-pastor-info').show();

        // hide and show divs
        $('.planning-nav').hide();
        $('.work-area-container[data-quota-id="' + workPastorId + '"]').addClass('active');
        $('.new-responsibility').hide();
        $('.planning-chart-container').show();

        // Draw only after the chart container is visible and layout has settled.
        requestAnimationFrame(function(){
            requestAnimationFrame(function(){
                drawPlanningChart();
            });
        });
    }else{
        $('.planning-chart-container').hide();

        $('.planning-pastor-info').hide();
        $('.planning-nav').show();
        $('.new-responsibility').show();

        // show all work areas quota containers or just one
        if (workQuotaId == 'all') {
            $('.work-area-container[data-work-area-id="' + workAreaId + '"]').addClass('active');
        } else {
            $('.work-area-container[data-work-area-id="' + workAreaId + '"][data-quota-id="' + workQuotaId + '"]').addClass('active');
        }
    }

    highlightDeltaButton();
}

// Highlight the delta button of the current work area
function highlightDeltaButton() {
    var deltaButton = $('.work-quota-item[data-quota-id="delta"]');
    deltaButton.removeClass('active-delta');

    // check if the currently active work area has any delta
    var workAreaId = $('.work-area.active').data('work-area-id');
    var deltaContainer = $('.work-area-container[data-work-area-id="' + workAreaId + '"][data-quota-id="delta"]');

    if (deltaContainer.length && deltaContainer.hasClass('has-delta')) {
        if (!deltaButton.hasClass('active-delta')) {
            deltaButton.addClass('active-delta');
        }
    }
}

// highlight delta in planning nav on the left
function highlightDeltaPlanningNav() {
    var workAreaNav = $('.work-area');

    if (workAreaNav.length) {
        workAreaNav.each(function() {
            var workArea = $(this);
            workArea.removeClass('active-delta');
            var workAreaId = workArea.data('work-area-id');
            var deltaContainer = $('.work-area-container[data-work-area-id="' + workAreaId + '"][data-quota-id="delta"]');

            if (deltaContainer.length && deltaContainer.hasClass('has-delta')) {
                if (!workArea.hasClass('active-delta')) {
                    workArea.addClass('active-delta');
                }
            }
        });
    }
}

function setDeltaOnLoad(){
    let deltaContainers = $('.work-area-container[data-quota-id="delta"]');

    deltaContainers.each(function(){
        let deltaContainer = $(this);

        if(deltaContainer.find('.display-cell.cell-sum span').length > deltaContainer.find('.display-cell.cell-sum span:empty').length){
            deltaContainer.addClass('has-delta');
        }
    });
}

function showPastorInfo(){
    togglePastors();
    if($('.work-pastor.active').length){
        var workPastorId = $('.work-pastor.active').data('pastor-id');

        let pastorFullname = '';
        let pastorActiveWorkQuota = 0;
        let pastorPossibleWorkDays = 0;
        let pastorSum = 0;

        const copyPastorWorkQuotasBtn = $('#copy-pastor-work-btn');
        const copyPastorWorkQuotasModal = $('#copy-pastor-work-quotas-modal');
        copyPastorWorkQuotasBtn.addClass('d-none');
        copyPastorWorkQuotasModal.find('select option').removeClass('d-none').attr('disabled', false);
        copyPastorWorkQuotasModal.removeAttr('data-pastor-id', workPastorId);
        if(workPastorId == 'total'){
            $('.planning-pastor-info .planning-pastor-info-row').eq(0).hide();

            $('.work-pastor:not(.work-pastor-is-inactive)').each(function(){
                let pastorId = $(this).data('pastor-id');
                if(pastorId != 'total'){
                    pastorActiveWorkQuota += parseFloat($(this).data('active-work-quota'));
                    pastorPossibleWorkDays += parseFloat($(this).data('possible-work-days'));
                }
            });

            // Calc pastor working hours
            $(`.work-area-container[data-quota-id="total"] .cell-sum span`).each(function(){
                if($(this).html()){
                    pastorSum += parseFloat($(this).html());
                }
            });
            pastorSum = pastorSum ? formatPlanningValue(pastorSum) : 0;
        }else{
            copyPastorWorkQuotasModal.find('select option[value="' + workPastorId + '"]').addClass('d-none').attr('disabled', true);
            copyPastorWorkQuotasModal.attr('data-pastor-id', workPastorId);
            copyPastorWorkQuotasBtn.removeClass('d-none');
            $('.planning-pastor-info .planning-pastor-info-row').eq(0).show();

            pastorFullname = $('.work-pastor.active').data('fullname');
            pastorActiveWorkQuota = $('.work-pastor.active').data('active-work-quota');
            pastorPossibleWorkDays = $('.work-pastor.active').data('possible-work-days');

            // Calc pastor working hours
            $(`.work-area-container[data-quota-id="${workPastorId}"] .cell-sum span`).each(function(){
                if($(this).html()){
                    pastorSum += parseFloat($(this).html());
                }
            });
            pastorSum = pastorSum ? formatPlanningValue(pastorSum) : 0;
        }


        $('.planning-pastor-info .pastor-info-fullname').html(pastorFullname);
        $('.planning-pastor-info .pastor-info-active-work-quota').html(pastorActiveWorkQuota);
        $('.planning-pastor-info .pastor-info-possible-work-days').html(pastorPossibleWorkDays);
        $('.planning-pastor-info .pastor-info-used-work-days').html(pastorSum);
    }
}

function drawPlanningChart(){
    let container = $('.planning-chart-container .planning-chart');
    let canvas = $(`<canvas></canvas>`);

    let workPastorId = $('.work-pastor.active').data('pastor-id');
    let chartMode = $('#planning-chart-mode').val() || 'work_area';
    let chartCategories1 = $('.planning-chart-container').data('chart-categories-1') || [];
    let chartCategories2 = $('.planning-chart-container').data('chart-categories-2') || [];
    let chartStatistics = $('.planning-chart-container').data('chart-statistics') || {};

    let labels = [];
    let data = [];
    let useBackendStatistics = false;

    const parseValue = (value) => {
        value = parseFloat(value);

        if(!value || isNaN(value)){
            return 0;
        }

        return value;
    };

    const setCodeChartDataFromStatistics = (statisticsKey, categories) => {
        if(!categories.length){
            return false;
        }

        let statisticsByScope = chartStatistics[statisticsKey];
        if(!statisticsByScope){
            return false;
        }

        let scopeKey = workPastorId == 'total' ? 'total' : `${workPastorId}`;
        let statisticsForScope = statisticsByScope[scopeKey] || {};

        categories.forEach((category) => {
            let categoryId = `${category.id}`;
            let categoryStats = statisticsForScope[categoryId] || {};
            let days = parseValue(categoryStats.days);
            let percent = parseValue(categoryStats.percent);

            labels.push(`${category.label} (${formatPlanningValue(days, 1)} Arbeitstage, ${percent}%)`);
            data.push(percent);
        });

        return true;
    };

    if(chartMode == 'custom_category_1'){
        useBackendStatistics = setCodeChartDataFromStatistics('custom_category_1', chartCategories1);
    }else if(chartMode == 'custom_category_2'){
        useBackendStatistics = setCodeChartDataFromStatistics('custom_category_2', chartCategories2);
    }

    if(!useBackendStatistics){
        $('.work-area').each(function(){
            labels.push($(this).data('work-area-label'));
        });

        $(`.work-area-container[data-quota-id="${workPastorId}"]`).each(function(){
            let sum = 0;
            $(this).find('.cell-sum > span').each(function(){
                let val = parseValue($(this).html());
                sum += val;
            });

            data.push(sum);
        });
    }

    container.empty();
    container.append(canvas);
    const ctx = canvas[0].getContext('2d');
    new Chart(ctx, {
        type: 'pie',
        data: {
            labels: labels,
            datasets: [{
                data: data
            }]
        }
    });


    $('.planning-chart-container').show();
}

function initPlanningChartMode(){
    $('#planning-chart-mode').change(function(){
        if($('.work-pastor.active').length){
            drawPlanningChart();
        }
    });
}


function formatPlanningValue(value, decimals = 2) {
    if (value === '' || isNaN(value)) {
        return ''; // Return an empty string for non-numeric or empty input
    }

    let number = Number.parseFloat(value);

    // Check if the number is an integer
    if (Math.floor(number) === number) {
        return number.toString(); // Return integer as string without decimal places
    }

    // Kaufmännische Runden for non-integer values
    let factor = Math.pow(10, decimals);
    number = Math.round(number * factor) / factor;

    // Format the number with specified decimals
    return number.toFixed(decimals);
}

function calculateRow(row) {
    if (typeof row === 'undefined') {
        var row = null;
    }

    // calculate target
    var actual = row.find('.input-actual').val() || 0;
    if(actual && actual.includes(',')){
        actual = actual.replace(/,/g, '.')
        row.find('.input-actual').val(actual);
    }
    actual = parseFloat(actual);

    var change = row.find('.input-change').val() || 0;
    if(change && change.includes(',')){
        change = change.replace(/,/g, '.')
        row.find('.input-change').val(change);
    }
    change = parseFloat(change);

    var target = parseFloat(actual + change) || 0;
    let canChangeToMinus = row.find('td.cell-name:contains("Besondere und übrige Aufgaben")');
    if (canChangeToMinus.length) {
        target = formatPlanningValue(target);
    } else {
        target = (target > 0) ? formatPlanningValue(target) : '';
    }

    row.find('.cell-target span').html(target);
    row.find('.input-target').val(target);

    // calculate sum
    var factor = row.find('.input-factor').val();
    if(factor && factor.includes(',')){
        factor = factor.replace(/,/g, '.')
        row.find('.input-factor').val(factor);
    }

    var sum = parseFloat(target * factor) || 0;
    sum = (sum) ? formatPlanningValue(sum) : '';

    // Transform sum into days format
    var format = row.find('.input-display_mode').val() || 'days';
    let sumInDays = sum;
    if(format != 'days'){
        if(format == 'hours'){
            sumInDays = convertWorkHoursToDays(sum);
        }else if(format == 'lessons'){
            sumInDays = convertWorkLessonsToDays(sum);
        }

        sumInDays = (sumInDays) ? formatPlanningValue(sumInDays) : '';
    }

    row.find('.cell-sum span').html(sumInDays);
    row.find('.input-sum').val(sum);

    calculateDelta(row.closest('.work-area-container'));
    showPastorInfo();
}

function calculateDelta(workArea) {
    if (typeof workArea === 'undefined') {
        var workArea = null;
    }

    if (workArea) {
        var workAreaId = workArea.data('work-area-id');

        // get all workAreaContainers
        var workAreaContainers = $('.work-area-container[data-work-area-id="' + workAreaId + '"]');

        if (workAreaContainers.length) {
            let totalContainer = workAreaContainers.filter('[data-quota-id="total"]');
            let deltaContainer = workAreaContainers.filter('[data-quota-id="delta"]');
            let pastorContainers = workAreaContainers.filter(function(){
                let container = $(this);
                let quotaId = container.data('quota-id');

                if (quotaId == 'total' || quotaId == 'delta') {
                    return false;
                }

                return !container.hasClass('work-pastor-is-inactive');
            });

            let hasDelta = false;
            deltaContainer.removeClass('has-delta');

            // Loop on every row
            totalContainer.find('.input-row').each(function(){
                let row = $(this);
                let rowId = row.data('row-id');

                // Row Display Mode
                let displayMode = row.find('.input-display_mode').val() || 'days';

                // Find out the amount of work the row has to reach => let totalWorkToReach
                let targetTotalRow = row.find('.input-target').val();
                targetTotalRow = convertToNumber(targetTotalRow);

                let factorTotalRow = row.find('.input-factor').val();
                factorTotalRow = convertToNumber(factorTotalRow);

                let sortType = row.find('.input-display_mode').val();
                let totalWorkToReach = targetTotalRow * factorTotalRow;
                let totalWorkToReachReal = calculateBySortChoice(sortType, totalWorkToReach)
                //totalWorkToReach = convertToDays(totalWorkToReach, displayMode);
                totalWorkToReach = convertForCalc(totalWorkToReach);
                totalWorkToReachReal = convertForCalc(totalWorkToReachReal)

                // Find out the total amount of work of all pastors together => let totalWorkPastors
                let totalWorkPastors = 0;
                let totalWorkPastorsReal = 0;
                let totalActualPastors = 0;
                let totalTargetPastors = 0;
                pastorContainers.find(`[data-row-id="${rowId}"]`).each(function(){
                    let rowPastor = $(this);

                    let targetPastorRow = rowPastor.find('.input-target').val();
                    targetPastorRow = convertToNumber(targetPastorRow);

                    let factorPastorRow = rowPastor.find('.input-factor').val();
                    factorPastorRow = convertToNumber(factorPastorRow);


                    let displayModePastorRow = rowPastor.find('.input-display_mode').val();

                    let sortType = rowPastor.find('.input-display_mode').val();
                    let workPastorInDays = targetPastorRow * factorPastorRow;
                    let workPastorInDaysReal = calculateBySortChoice(sortType, workPastorInDays)
                    //workPastorInDays = convertToDays(workPastorInDays, displayModePastorRow);

                    totalWorkPastors += workPastorInDays;
                    totalWorkPastorsReal += workPastorInDaysReal;

                    // Sum other values just as info to show
                    let actualPastorRow = rowPastor.find('.input-actual').val();
                    totalActualPastors += convertToNumber(actualPastorRow);
                    totalTargetPastors += targetPastorRow;
                });

                totalTargetPastors = convertForCalc(totalTargetPastors);

                totalWorkPastors = convertForCalc(totalWorkPastors);
                totalWorkPastorsReal = convertForCalc(totalWorkPastorsReal);

                let delta = totalWorkToReach - totalWorkPastors;
                let deltaReal = totalWorkToReachReal - totalWorkPastorsReal;
                let deltaShow = 0;
                let deltaShowReal = 0;
                if(deltaReal != 0){
                    deltaShow = delta;
                    deltaShow = convertToDays(deltaShow, displayMode);
                    deltaShow = formatPlanningValue(deltaShow);

                    deltaShowReal = deltaReal
                    deltaShowReal = convertToDays(deltaShowReal, displayMode);
                    deltaShowReal = formatPlanningValue(deltaShowReal);
                }

                if(deltaShowReal == 0){
                    // NO Delta
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-sum span`).html('');
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-actual span`).html('');
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-target span`).html('');
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta`).val('');
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta-actual`).val('');
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta-target`).val('');

                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-over`).hide();
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-under`).hide();
                }else{
                    // HAS Delta
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-actual span`).html(totalActualPastors);
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta-actual`).val(totalActualPastors);

                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-target span`).html(totalTargetPastors);
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta-target`).val(totalTargetPastors);

                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-sum span`).html(deltaShow);
                    totalContainer.find(`.input-row[data-row-id="${rowId}"] .input-delta`).val(deltaShow);

                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-over`).hide();
                    deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-under`).hide();
                    if (delta > 0) {
                        deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-under .delta-amount`).html(Math.abs(deltaShow));
                        deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-under`).show();
                    } else {
                        deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-over .delta-amount`).html(Math.abs(deltaShow));
                        deltaContainer.find(`.input-row[data-row-id="${rowId}"] .cell-description .delta-notice-over`).show();
                    }

                    hasDelta = true;
                }
            });

            if (hasDelta) {
                deltaContainer.addClass('has-delta');
            }
        }
    }

    highlightDeltaButton();
    highlightDeltaPlanningNav();
}

function calculateBySortChoice(type, value)
{
    if(['days', 'members'].includes(type)) {
        return value;
    }
    if(['hours', 'lessons'].includes(type)) {
        value = value / 8.73
        if(type === 'hours') {
            return value;
        }
        return value * 0.75;
    }
    return value;
}

function calculateAllDeltas(){
    togglePastors();
    $('.work-area-container.pastor-total').each(function(){
        calculateDelta($(this));
    });
}

function copyPastorWorkQuotasListener(){
    const copyPastorWorkQuotasModal = $('#copy-pastor-work-quotas-modal');
    $('#copy-pastor-work-btn').on('click', function(event){
        copyPastorWorkQuotasModal.modal('show');
    });
    $('#pastor-work-quotas-copy-modal-btn').on('click', function(event){
        event.preventDefault();
        const parentElement = copyPastorWorkQuotasModal.find('.modal-footer');
        new Promise((resolve) => {
            parentElement.children().hide();
            parentElement.append('<div class="loader-text"><i class="fas fa-spinner fa-spin"></i><p>Daten werden übertragen, bitte warten...</p></div>');
            setTimeout(() => {
                resolve();
            }, 500);
        }).then(() => {
            copyPastorWorkQuotasHandler();
        }).finally(() => {
            copyPastorWorkQuotasModal.modal('hide');
            parentElement.find('.loader-text').remove();
            parentElement.children().show();
        });
    });
}

function copyPastorWorkQuotasHandler(){
    const copyPastorWorkQuotasModal = $('#copy-pastor-work-quotas-modal');
    const pastorSelected = copyPastorWorkQuotasModal.find('select option:selected').val();
    const currentPastor = copyPastorWorkQuotasModal.data('pastor-id');

    if (pastorSelected && currentPastor) {
        const currentPastorWorkAreaContainerSelects = $(`.work-area-container.pastor-${currentPastor}`).find('select');
        const currentPastorWorkAreaContainer = $(`.work-area-container.pastor-${currentPastor}`).find('input');

        $(`.work-area-container.pastor-${pastorSelected}`).find('select').each(function (index) {
            const select = $(this);

            const targetValue = select.val();
            const currentSelect = currentPastorWorkAreaContainerSelects.eq(index);
            currentSelect.val(targetValue);
        });

        $(`.work-area-container.pastor-${pastorSelected}`).find('input').each(function (index) {
            const input = $(this);

            const targetValue = input.val();
            const currentInput = currentPastorWorkAreaContainer.eq(index);
            currentInput.val(targetValue).trigger('input');
        });
    } else {
        console.error('Error: No pastor selected or current pastor data missing.');
    }
}

function togglePastors() {
    let dateForCalcWorkload = $('[name="date_for_calc_workload"]').val();
    if(dateForCalcWorkload == ''){
        $(`.work-quota-item`).removeClass('work-pastor-is-inactive');
        $('.work-pastor').removeClass('work-pastor-is-inactive');
        $('.work-area-container').removeClass('work-pastor-is-inactive');
        return;
    }

    dateForCalcWorkload = dateForCalcWorkload.split('.');
    dateForCalcWorkload = dateForCalcWorkload[2] + '-' + dateForCalcWorkload[1] + '-' + dateForCalcWorkload[0];

    $('.work-pastor').each(function(){
        let pastorRow = $(this);
        let pastorId = pastorRow.data('pastor-id');
        if(pastorId != 'total'){
            let isWorking = false;
            let workQuotas = pastorRow.data('work-quotas');
            workQuotas.forEach(function(v){
                let from = v.from.substring(0, 10);
                let to = v.to.substring(0, 10);
                if(dateForCalcWorkload >= from && dateForCalcWorkload <= to){
                    isWorking = true;

                    pastorRow.attr('data-active-work-quota', formatPlanningValue(v.work_quota));
                    pastorRow.attr('data-possible-work-days', formatPlanningValue(v.work_days));
                }
            });

            if(isWorking){
                $(`.work-quota-item[data-quota-id="${pastorId}"]`).removeClass('work-pastor-is-inactive');
                $(`.work-area-container[data-quota-id="${pastorId}"]`).removeClass('work-pastor-is-inactive');
                pastorRow.removeClass('work-pastor-is-inactive');
            }else{
                $(`.work-quota-item[data-quota-id="${pastorId}"]`).addClass('work-pastor-is-inactive');
                $(`.work-area-container[data-quota-id="${pastorId}"]`).addClass('work-pastor-is-inactive');
                pastorRow.addClass('work-pastor-is-inactive');
            }
        }
    });
}

function btnDateForCalcWorkloadHandler(){

    togglePastors();

    $('[name="date_for_calc_workload"]').change(function(){
        togglePastors();

        calculateAllDeltas();
    });
}

const init = () => {
    // Calculate all delta values on page load. Usually it only execute after a copy of the planning.
    if($('#planning-add-edit-container').hasClass('calc-delta-on-loading')){
        calculateAllDeltas();
    }

    $(document).ready(function() {
        showPlanningLastWorkArea();
        initNavAndPastorTabs();
        changesInPlanningMask();
        initPlanningChartMode();

        btnDateForCalcWorkloadHandler();

        saveBtn();
        unsavedPlanningWarning();

        newResponsibility();
        renameResponsibility();

        copyPastorWorkQuotasListener();

        $('body').removeClass('loading');
    });

    $(window).on("scroll", function() {
        unsavedPlanningWarning();
    });

    window.onload = function(){
        // show alert before exit the page -> only in case there is changes not saved
        window.addEventListener('beforeunload', onBeforeUnload);
    }
}

export default init;
